import { gql } from '@apollo/client';

export const BusinessQuery = gql`
  query BusinessQuery {
    business {
      business {
        message
        isSomething
      }
      ok
      error
    }
  }
`;
